<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Common",
  computed: {
    ...mapState(["down"])
  },
  methods: {
    ...mapActions([
      "setNewsTabList",
      "setAudioSrc",
      "setAdList",
      "setNewsSwiperList"
    ]),
    downFun(type) {
      switch (type) {
        case "ios":
          this.downUrl(this.down.iosUrl);
          break;
        case "and":
          this.downUrl(this.down.androidUrl);
          break;
        case "pc":
          this.downUrl(this.down.pcUrl);
          break;
        case "dw":
          this.downUrl(this.down.dwUrl);
          break;
        default:
          this.$toast({
            message: "请添加下载地址链接",
            duration: 1000
          });
      }
    },
    downUrl(url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$toast({
          message: "敬请期待",
          duration: 1000
        });
      }
    },
    jumpDetail(n) {
      const { href } = this.$router.resolve({
        path: "/detail",
        query: { sn: n.sn }
      });
      window.open(href, "_blank");
    },
    moveTo(page) {
      this.$router.push({ path: "/", query: { page } });
    },
    async getConfig() {
      try {
        const {
          data: { items }
        } = await this.$api.getKMSConfig("config", { f: "data" });
        if (items.length === 0) return;
        const {
          topMediaUrl,
          thumb,
          fftPic,
          videoUrl,
          topAudioUrl,
          adList,
          imgList,
          nImg
        } = items[0];
        this.bgSrc = topMediaUrl;
        this.bgPoster = thumb;
        this.fftSrc = fftPic;
        this.videoUrl = videoUrl;
        this.setAudioSrc(topAudioUrl);
        this.setAdList(adList);
        this.setNewsSwiperList(imgList);
        this.bgUrl = nImg;
      } catch (error) {
        this.$toast(error?.desc || "Error");
      }
    }
  }
};
</script>
